<template>
  <div class="">
    <!-- Form Builder Renderer for Step 3 -->
    <FormBuilderRenderer 
      v-if="use_form_builder && form_builder_config"
      :form-builder-config="form_builder_config"
      step="step_3"
      :gateways="gateways"
    />

    <!-- Legacy Fields (Fallback) -->
    <template v-else>
    <div class="wpcm-recurring-btns">
      <ul class="d-inline-flex" v-if="show_recurring">
          <li
          class="m-0"
          v-if="strings"
          @click.prevent="setRecurring(false)"
        >
          <a href="#" :class="!store.recurring && 'active'">{{ strings.one_time }}</a>
        </li>
        <li
          class="m-0"
          v-if="strings"
          @click.prevent="setRecurring(true)"
        >
          <a href="#" :class="store.recurring && 'active'">{{ strings.recurring }}</a>
        </li>
      
      </ul>
    </div>
    <div class="wpcm-payment-gateways mt-3">
      <div class="mb-3">
        <ul class="wpcm-gateway-list" v-if="gateways">
          <li v-for="(gateway, gateway_id) in gateways" :key="gateway_id">
            <a
              @click.prevent="store.payment_method = gateway.id"
              :class="[(gateway.id === store.payment_method) && 'active']"
              title=""
              href="#"
            >
              <span v-if="gateway.icon"><img :src="gateway.icon" alt=""></span>
              {{ gateway.title ? gateway.title : gateway.name }}
            </a>
          </li>
        </ul>
      </div>

      <div
        class="wpcm-gateway-testing-info mb-3"
        v-if="selectedTestingInfo"
      >
        <div
          class="wpcm-gateway-testing-info__text"
          v-html="selectedTestingInfo"
        ></div>
      </div>

      <slot name="gateway_data"></slot>
      <slot name="billing_info"></slot>
      <slot></slot>
    </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useDonationFormsStore } from '../store';
import FormBuilderRenderer from './FormBuilderRenderer.vue';

const store = useDonationFormsStore();
const props = defineProps([
  "gateways",
  "show_recurring",
  "strings",
  "use_form_builder",
  "form_builder_config"
]);

const setValue = (key, val) => {
  store[key] = val;
};

const setRecurring = (isRecurring: boolean) => {
  store.recurring = isRecurring;
  store.amount = 0; // Reset the amount
};

const selectedTestingInfo = computed(() => {
  const selected = store.payment_method;
  if (!selected || !props.gateways) return '';
  const list: any = props.gateways;
  const match: any = Array.isArray(list)
    ? list.find((g: any) => g && g.id === selected)
    : Object.values(list).find((g: any) => g && g.id === selected);
  return (match && match.testing_info) ? match.testing_info : '';
});

const getBack = () => {}

</script>